import { Injectable, Injector, Inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, Subject, empty } from 'rxjs';
import { catchError, tap, switchMap } from 'rxjs/operators';
import { NGX_CM_AUTH_PROVIDER } from '../_internals';
import { NgxCmAuthProvider } from '../models/ngx-auth-provider';

@Injectable()
export class NgxCmInterceptorService implements HttpInterceptor {

  refreshTokenInProgress = false;

  tokenRefreshedSource = new Subject();
  tokenRefreshed$ = this.tokenRefreshedSource.asObservable();

  constructor(
    @Inject(NGX_CM_AUTH_PROVIDER) private authService: NgxCmAuthProvider
  ) { }

  addAuthHeader(request) {
    const authHeader = this.authService.GetAuthorizationHeader();
    if (authHeader) {
      return request.clone({
        setHeaders: {
          'Authorization': authHeader
        }
      });
    }
    return request;
  }

  refreshToken() {
    if (this.refreshTokenInProgress) {
      return new Observable(observer => {
        this.tokenRefreshed$.subscribe(() => {
          observer.next();
          observer.complete();
        });
      });
    } else {
      this.refreshTokenInProgress = true;

      return this.authService.RefreshToken()
        .pipe(
          tap(() => {
            this.refreshTokenInProgress = false;
            this.tokenRefreshedSource.next();
          }));
    }
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Handle request
    request = this.addAuthHeader(request);

    // Handle response
    return next.handle(request).pipe(
      catchError(error => {
        if (error.status === 401) {
          return this.refreshToken().pipe(
            switchMap(() => {
              request = this.addAuthHeader(request);
              return next.handle(request);
            }),
            catchError(() => {
              // logout
              this.authService.Logout();
              return new Observable(observer => {
                this.authService.Login().subscribe(() => {
                  observer.complete();
                  return next.handle(request);
                });
              });
            })
          );
        }
        return Observable.throw(error);
      })
    );
  }
}
